import { DataViewProps } from '../../view/common/DataView';
import { TaskDef } from '../mgmt/api';
import { useStatefulWebSocketListener, useWebSocketListener } from '../WebSocketListener';

export const useTaskDefListener = function (
    props: DataViewProps<TaskDef>
) {
    const taskDef = props.data;
    const id = taskDef?.id || 'none';

    return useStatefulWebSocketListener({
        ...props,
        endPoint: '/agent/websocket',
        topic: id && `/topic/taskDef/${id}` || undefined
    });
};
